import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogRef } from '../../services/modal.service';
import { ModalService } from '../../services/modal.service';

import { User } from '../../models/user.model';
import { UserService } from '../../services/user.service';
import { ARColzaService } from '../../services/agrorendement-colza.service';
import { ARBleService } from '../../services/agrorendement-ble.service';
import { AROrgeService } from '../../services/agrorendement-orge.service';
import { UserComponent } from './users.component';
import { showErrorMessage } from '../../utils/utils';
import { CommonModule } from '@angular/common';

export class ConfirmDeleteUserDialogContext {
  user: User;
  parent: UserComponent;
  showClose: boolean;
  isBlocking: boolean;
  size: string;
}

@Component({
  standalone: true,
  selector: 'confirm-del-user-dlg',
  templateUrl: 'confirm-delete-dialog.component.html',
  providers: [UserService, ARColzaService, ARBleService, AROrgeService],

  imports: [CommonModule],
})
export class ConfirmDeleteUserDialogComponent {
  error: any;
  context: ConfirmDeleteUserDialogContext;

  user: User;

  constructor(
    public dialog: DialogRef<ConfirmDeleteUserDialogContext>,
    private userService: UserService,
    private router: Router,
    private modal: ModalService,
  ) {
    this.context = dialog.context;
    this.user = this.context.user;
  }

  delete(user: User) {
    this.userService.delete(user).subscribe(
      (res) => {
        this.dialog.close();
        this.router.navigate(['/users']);
        this.context.parent.onChangeTable();
      },
      (error) => this.handleDeleteError(error),
    );
  }

  dismiss() {
    this.dialog.close();
  }

  handleDeleteError(error: any) {
    this.dialog.close();
    const msg = JSON.parse(error._body);
    if (error.status === 400) {
      if (msg.errorMessage.includes('*/', 0)) {
        const error = msg.errorMessage.replace('*/', '');
        showErrorMessage(this.modal, error);
      } else {
        showErrorMessage(this.modal, 'Cet utilisateur ne peut pas être supprimé');
      }
    } else showErrorMessage(this.modal, 'Cet utilisateur ne peut pas être supprimé');
  }
}
